export enum SchoolCertificate {
  NoDegree = 'no_degree',
  SecondarySchoolCertificate = 'secondary_school_certificate',
  IntermediateDegree = 'intermediate_degree',
  VocationalQualificationCertificate = 'vocational_qualification_certificate',
  UniversityQualificationCertificate = 'university_qualification_certificate',
}

export const SCHOOL_CERTIFICATE_I18N = {
  [SchoolCertificate.NoDegree]: 'Ohne Abschluss',
  [SchoolCertificate.SecondarySchoolCertificate]: 'Hauptschulabschluss',
  [SchoolCertificate.IntermediateDegree]: 'Mittlerer Abschluss',
  [SchoolCertificate.VocationalQualificationCertificate]: 'Fachhochschulreife',
  [SchoolCertificate.UniversityQualificationCertificate]: 'Allgemeine Hochschulreife',
};
